import { ADD_ERROR, CLOSE_ERROR } from '../actions/index';

export default function (state = [], action) {
	switch (action.type) {
		case ADD_ERROR:
			return [...state, action.payload];
		case CLOSE_ERROR:
			return [action.payload];
		default:
			return state;
			break;
	}
}
